function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon-settings");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Icon-settings",
  transform: "translate(-2.000000, -2.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "#D8D8D8",
  opacity: 0,
  x: 0,
  y: 0,
  width: 14,
  height: 14
}), React.createElement("g", {
  id: "noun_setting_2382109-copy",
  opacity: 0.6,
  transform: "translate(2.000000, 2.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M9.95014259,4.42175206 L9.92165264,4.16851958 L8.6609724,3.8831872 C8.5895099,3.63612818 8.49284701,3.39709171 8.37251167,3.16985626 L9.05983169,2.08915989 L8.91738194,1.89299388 C8.67737282,1.58611592 8.40114706,1.30947045 8.09473467,1.06909665 L7.89886627,0.912163844 L6.80556449,1.61479482 C6.57868446,1.4942537 6.34000824,1.39744295 6.09331576,1.32589579 L5.80841628,0.0633000272 L5.56981295,0.0347667896 C5.1913569,-0.0115889299 4.80867105,-0.0115889299 4.430215,0.0347667896 L4.1773667,0.0633000272 L3.89246722,1.32589579 C3.64578301,1.39746687 3.4071092,1.49427664 3.18021849,1.61479482 L2.10116168,0.926430463 L1.90529328,1.06909665 C1.59888089,1.30947045 1.32265513,1.58611592 1.08264601,1.89299388 L0.925951291,2.08915989 L1.61327131,3.18412288 C1.49293597,3.41135833 1.39627307,3.6503948 1.32481057,3.89745382 L0.0641303382,4.1827862 L0.0356403894,4.43601868 C-0.0118801298,4.81497341 -0.0118801298,5.19839345 0.0356403894,5.57734818 L0.0641303382,5.83058066 L1.32481057,6.11591304 C1.39627307,6.36297206 1.49293597,6.60200853 1.61327131,6.82924398 L0.940196265,7.89567373 L1.09689098,8.09183974 C1.33247454,8.3978756 1.60388302,8.67448626 1.90529328,8.91573697 L2.10116168,9.07266978 L3.19446347,8.38430542 C3.42135417,8.5048236 3.66002799,8.60163337 3.90671219,8.67320445 L4.19161168,9.93580022 L4.44445997,9.96433345 C4.82284211,10.0118888 5.20567579,10.0118888 5.58405793,9.96433345 L5.83690622,9.93580022 L6.12180571,8.67320445 C6.36849818,8.60165729 6.60717441,8.50484655 6.83405443,8.38430542 L7.92735622,9.07266978 L8.12322462,8.91573697 C8.41963448,8.67362219 8.68622748,8.39704571 8.91738194,8.09183974 L9.07407666,7.89567373 L8.38675665,6.80071074 C8.50709198,6.57347529 8.60375488,6.33443882 8.67521738,6.0873798 L9.93589762,5.80204743 L9.96438756,5.54881494 C10.0118708,5.16985788 10.0118708,4.7864425 9.96438756,4.40748544 L9.95014259,4.42175206 Z M7.13676014,4.99241681 C7.13676014,6.17430221 6.1801063,7.13240963 5.00001398,7.13240963 C3.81992166,7.13240963 2.86326781,6.17430221 2.86326781,4.99241681 C2.86326781,3.81053142 3.81992166,2.852424 5.00001398,2.852424 C6.1801063,2.852424 7.13676014,3.81053142 7.13676014,4.99241681 Z",
  id: "Shape"
}))));

var SvgHeaderSettings = function SvgHeaderSettings(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHeaderSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/header-settings.66d30655.svg";
export { ForwardRef as ReactComponent };